import { useContext } from 'react';

import { Tkv2OrderContext } from '../Tkv2OrderContext.ts';
import { Tkv2OrderContext as Tkv2OrderContextType } from '../types.ts';

export function useTkv2NullableOrderContext(): Tkv2OrderContextType | null {
  const orderContext = useContext(Tkv2OrderContext);

  if (orderContext) return orderContext;

  return null;
}
